import Vue from "vue";
import Vuex, { Store } from "vuex";

import echarts from "./modules/echarts";
import role from "./modules/role";
Vue.use(Vuex);
import { authentication } from "@/api/login";

export default new Store({
  state: {
    oaState: "0", //校园OA侧边栏选中状态
    docmState: "0", //公文管理侧边栏选中状态
    messageobj: {},
    numberobj: {},
    detailpage: {},
    file_list: [],
    groupState: false, // 公用状态，头部header点击返回是需要提示弹窗，将状态改为true
    groupStatethree: false, // 公用状态，头部header点击返回是需要提示弹窗，将状态改为true
    title: "", // 公用状态提示标语，将提示标题存在此字段
    tiwarning: "", // 公用状态提示标语，将提示标题存在此字段
    routerStateNum: 0,
    loginState: false, // 公用状态，登录弹窗
    versionsstate: false, // 版本授权弹窗
    eduCubeState: false, // 公用状态 ，教育魔方绑定弹窗
    lostat: false,
    testpaperState: false,
    metaobj: {},
    studentTipicDetail: {}, // 错题本查看详情轮播图数据
    xkindexModel: 0,// 教务巡课默认展示模块
    // school:{},
    ImgSrc: "",
  },
  modules: {
    // 配置应用中所有的功能相关的配置 总状态
    echarts: echarts,
    role: role
  },
  mutations: {
    updateImgSrc(state, row) {
      state.ImgSrc = row;
    },

    // 更改校园OA侧边栏选中状态
    oaState(state, row) {
      state.oaState = row;
    },

    //更改公文管理侧边栏选中状态
    docmState(state, row) {
      state.docmState = row;
    },
    // 更改消息信息方法调用  存当前更改的消息对象
    setmessage(state, row) {
      state.messageobj = row;
    },
    // 修改设备型号   序列号
    setnumber(state, row) {
      state.numberobj = row;
    },
    // 序列号修改
    setdetailpage(state, row) {
      state.detailpage = row;
    },
    // 教学记录文件预览
    Save_preview(state, row) {
      state.file_list = row;
    },
    // header 返回弹窗
    setGroup(state, row) {
      state.groupState = row;
    },
    // header 返回弹窗
    setGroupthree(state, row) {
      state.groupStatethree = row;
    },
    // header 返回弹窗提示标题
    esctitle(state, row) {
      state.title = row;
    },
    // header 返回弹窗提示标题
    esctitlewarning(state, row) {
      state.tiwarning = row;
    },
    // 试卷新增状态返回阻断提示状态
    testpaperStatea(state, row) {
      state.testpaperState = row;
    },
    // 路由跳转点击次数 统计
    routerNum(state, row) {
      state.routerStateNum = row;
    },
    // 全局弹窗登录
    loginState(state, e) {
      // 全局不弹弹窗了，改成跳机构登录了
      if(e === true) {
        // 获取机构登录地址
        let path = window.location.href;
        let index = path.lastIndexOf("#");
        path = path.substring(index + 2, path.length);
        const type = "token";
        const data = 1;
        authentication(type, data, path).then((res) => {
          if (res.code === 200) {
            window.location.href = res.data[0].url;
          }
        });
      } else {
        state.loginState = e;
      }
    },
    loginNewState(state, e) {
      // 新的全局登录弹出框方法
      state.loginState = e;
    },
    // 公用状态弹窗
    versions(state, e){
      state.versionsstate = e;
    },
    // 修改默认密码状态
    userlodpas(state, val) {
      state.lostat = val;
    },
    montedMeta(state, val) {
      state.metaobj = val || {};
    },
    // 修改学校
    // setschool(state,row){
    //   state.school = row
    // }
    studentViewTopic(state, val) {
      state.studentTipicDetail = val;
    },
    // 教育魔方绑定弹窗
    eduCubeState(state, e) {
      state.eduCubeState = e;
    },
    setxkModel(state,val){
      state.xkindexModel = val;
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js